import { TableColumnsType } from "antd";
import moment from "moment";

import { RequestDetailsTableType } from "../../models";

export const requestDetailsColumns = () => {
  const columns: TableColumnsType<RequestDetailsTableType> = [
    {
      title: "Naziv klijenta",
      dataIndex: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Dodatna informacija",
      dataIndex: "note",
      responsive: ["sm"],
    },
    {
      title: "Datum",
      dataIndex: "updatedAt",
      width: 190,
      responsive: ["lg"],
      render: (date: string) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
    },
  ];

  return columns;
};
